import { render, staticRenderFns } from "./h-switch.vue?vue&type=template&id=62af3ff3&scoped=true"
import script from "./h-switch.vue?vue&type=script&lang=js"
export * from "./h-switch.vue?vue&type=script&lang=js"
import style0 from "./h-switch.vue?vue&type=style&index=0&id=62af3ff3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62af3ff3",
  null
  
)

export default component.exports